<div class="signing-page-wrapper">
    <span class="signing-sidebar-openIcon" (click)="toggleSidebar('signing-right-sidebar')">
        <i data-feather="list" [size]="22"></i>
    </span>

    <div class="template-page-container">
        <div class="template-page p-0" *ngIf="roleDetail?.roleable?.status === signingStatusEnum.UPLOADED || roleDetail?.roleable?.is_uploaded">
            @if (uploadedFileType === "pdf") {
                <div *ngFor="let img of pdfPages">
                    <img *ngIf="img" [src]="img.src" class="pdf-img">
                </div>
            } @else if(uploadedFileType === "img") { 
                <img [src]="roleDetail?.uploaded_pdf | signingPageImage:roleId | async" class="pdf-img">
            }
        </div>
        <div class="template-page" [innerHTML]="templateContent" *ngIf="roleDetail?.roleable?.status !== signingStatusEnum.UPLOADED">
        </div>
    </div>
    @if (!loadingSigningArea && [signingStatusEnum.SIGNED, signingStatusEnum.COMPLETED].includes(roleDetail.roleable.status) && roleDetail.roleable.status_updated_manually === 0) {
        <!-- Verification Page Html Start -->
        <div class="verification-page-container">
            <app-verification-page [roleId]="roleId" [document_id]="roleDetail?.roleable.id" [is_sender]="is_sender" [roleDetail]="roleDetail"></app-verification-page>
        </div>
        <!-- / Verification Page Html End -->
    }

    <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade signing-right-sidebar show" name="signing-right-sidebar">
        <div class="slideout-content">
            <div class="modalsd modal-slide-in sdfade" id="modals-slide-in">
                <div class="modal-dialog">
                    <form class="add-new-user modal-content pt-0">
                        <div class="modal-header mb-1 d-flex justify-content-between align-items-center px-2 py-1">
                            <div class="d-flex justify-content-end align-items-center text-dark cursor-pointer">
                                
                            </div>
                        </div>
                        <div class="modal-body flex-grow-1 p-0">
                            <div class="signing-sidebar-wrapper">
                                @if (!loadingSigningArea) {
                                    <app-signing-sidebar [roleDetail]="roleDetail" [view]="'senderArea'" [roleId]="roleId" [document_id]="roleDetail?.roleable.id" [is_sender]="is_sender"></app-signing-sidebar>       
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </core-sidebar>
</div>